import CompanyDetailsDumps from './CompanyDetailsDumps';

export default CompanyDetailsDumps;
